import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class'

// generic widget for file input
var FileUpload = createReactClass({
    propTypes: {
        onChange: pt.func
    },

    getDefaultProps: function () {
        return {
            onChange: function noop () {}
        };
    },

    getInitialState: function () {
        return {
            previewName: ''
        };
    },

    onFileChange: function (ev) {
        function parsePathname (path) {
            return path.replace(/C:\\fakepath\\/i, '');
        }
        var name = parsePathname(ev.target.value);
        this.setState({ previewName: name });
        this.props.onChange(ev);
    },

    render: function () {
        return (<div>
            <div className="input-group">
                <span className="input-group-btn">
                    <button type="button"
                        className="btn btn-primary"
                        onClick={function (ev) {
                            ev.preventDefault();
                            this.inputEl.click();
                        }.bind(this)}
                    >
                        {this.props.children || 'Select File…'}
                    </button>
                </span>

                <input
                    id="fileNamePreview"
                    className="form-control"
                    value={this.state.previewName}
                    readOnly
                />
            </div>

            <input
                onChange={this.onFileChange}
                ref={function (el) {
                    this.inputEl = el;
                }.bind(this)}
                type="file"
                className="hidden"
                name="media"
            />
        </div>);
    }
});

export default FileUpload;
